import { Record as record } from 'immutable';

import Split from './Split';

const defaults = {
    outwardSingle: null,
    inboundSingle: null,
    return: null,
    totalPrice: 0
};

class CheapestSplit extends record(defaults) {
    static fromJSON(json = {}) {
        return new CheapestSplit({
            outwardSingle: json.outwardSingle ? Split.fromJSON(json.outwardSingle) : null,
            inboundSingle: json.inboundSingle ? Split.fromJSON(json.inboundSingle) : null,
            return: json.return ? Split.fromJSON(json.return) : null,
            totalPrice: json.totalPrice || 0
        });
    }
}

export default CheapestSplit;
